var _linearGradient, _radialGradient, _linearGradient2, _radialGradient2, _radialGradient3, _radialGradient4, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256,
    viewBox: "0 0 256 256",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(1 0 0 -1 0 266)",
    gradientUnits: "userSpaceOnUse",
    x1: 63.33,
    x2: 241.67,
    y1: 84.03,
    y2: 84.03
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c59a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114a8b"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 161.83,
    cy: 68.91,
    gradientTransform: "matrix(1 0 0 -.95 0 248.84)",
    gradientUnits: "userSpaceOnUse",
    r: 95.38
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(1 0 0 -1 0 266)",
    gradientUnits: "userSpaceOnUse",
    x1: 157.35,
    x2: 45.96,
    y1: 161.39,
    y2: 40.06
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b9de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -340.29,
    cy: 62.99,
    gradientTransform: "matrix(.15 -.99 -.8 -.12 176.64 -125.4)",
    gradientUnits: "userSpaceOnUse",
    r: 143.24
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 113.37,
    cy: 570.21,
    gradientTransform: "matrix(-.04 1 2.13 .08 -1179.54 -106.69)",
    gradientUnits: "userSpaceOnUse",
    r: 202.43
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35c1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34c1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2fc2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2bc3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36c752"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 376.52,
    cy: 567.97,
    gradientTransform: "matrix(.28 .96 .78 -.23 -303.76 -148.5)",
    gradientUnits: "userSpaceOnUse",
    r: 97.34
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66eb6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66eb6e",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m235.68 195.46a93.73 93.73 0 0 1 -10.54 4.71 101.87 101.87 0 0 1 -35.9 6.46c-47.32 0-88.54-32.55-88.54-74.32a31.48 31.48 0 0 1 16.43-27.31c-42.8 1.8-53.8 46.4-53.8 72.53 0 73.88 68.09 81.37 82.76 81.37 7.91 0 19.84-2.3 27-4.56l1.31-.44a128.34 128.34 0 0 0 66.6-52.8 4 4 0 0 0 -5.32-5.64z",
    fill: "url(#a)",
    transform: "translate(-4.63 -4.92)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m235.68 195.46a93.73 93.73 0 0 1 -10.54 4.71 101.87 101.87 0 0 1 -35.9 6.46c-47.32 0-88.54-32.55-88.54-74.32a31.48 31.48 0 0 1 16.43-27.31c-42.8 1.8-53.8 46.4-53.8 72.53 0 73.88 68.09 81.37 82.76 81.37 7.91 0 19.84-2.3 27-4.56l1.31-.44a128.34 128.34 0 0 0 66.6-52.8 4 4 0 0 0 -5.32-5.64z",
    fill: "url(#b)",
    opacity: 0.35,
    transform: "translate(-4.63 -4.92)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m110.34 246.34a79.2 79.2 0 0 1 -22.74-21.34 80.72 80.72 0 0 1 29.53-120c3.12-1.47 8.45-4.13 15.54-4a32.35 32.35 0 0 1 25.69 13 31.88 31.88 0 0 1 6.36 18.66c0-.21 24.46-79.6-80-79.6-43.9 0-80 41.66-80 78.21a130.15 130.15 0 0 0 12.11 56 128 128 0 0 0 156.38 67.11 75.55 75.55 0 0 1 -62.78-8z",
    fill: "url(#c)",
    transform: "translate(-4.63 -4.92)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m110.34 246.34a79.2 79.2 0 0 1 -22.74-21.34 80.72 80.72 0 0 1 29.53-120c3.12-1.47 8.45-4.13 15.54-4a32.35 32.35 0 0 1 25.69 13 31.88 31.88 0 0 1 6.36 18.66c0-.21 24.46-79.6-80-79.6-43.9 0-80 41.66-80 78.21a130.15 130.15 0 0 0 12.11 56 128 128 0 0 0 156.38 67.11 75.55 75.55 0 0 1 -62.78-8z",
    fill: "url(#d)",
    opacity: 0.41,
    transform: "translate(-4.63 -4.92)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m156.94 153.78c-.81 1.05-3.3 2.5-3.3 5.66 0 2.61 1.7 5.12 4.72 7.23 14.38 10 41.49 8.68 41.56 8.68a59.56 59.56 0 0 0 30.27-8.35 61.38 61.38 0 0 0 30.43-52.88c.26-22.41-8-37.31-11.34-43.91-21.19-41.45-66.93-65.29-116.67-65.29a128 128 0 0 0 -128 126.2c.48-36.54 36.8-66.05 80-66.05 3.5 0 23.46.34 42 10.07 16.34 8.58 24.9 18.94 30.85 29.21 6.18 10.67 7.28 24.15 7.28 29.52s-2.74 13.33-7.8 19.91z",
    fill: "url(#e)",
    transform: "translate(-4.63 -4.92)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m156.94 153.78c-.81 1.05-3.3 2.5-3.3 5.66 0 2.61 1.7 5.12 4.72 7.23 14.38 10 41.49 8.68 41.56 8.68a59.56 59.56 0 0 0 30.27-8.35 61.38 61.38 0 0 0 30.43-52.88c.26-22.41-8-37.31-11.34-43.91-21.19-41.45-66.93-65.29-116.67-65.29a128 128 0 0 0 -128 126.2c.48-36.54 36.8-66.05 80-66.05 3.5 0 23.46.34 42 10.07 16.34 8.58 24.9 18.94 30.85 29.21 6.18 10.67 7.28 24.15 7.28 29.52s-2.74 13.33-7.8 19.91z",
    fill: "url(#f)",
    transform: "translate(-4.63 -4.92)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.3c71f90f3e8da1039843610d413b207b.svg";
export { ForwardRef as ReactComponent };